module.exports = __webpack_public_path__ + "img/status-on.7e9fa2ae.svg";